import { useMemo } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { DocumentStore } from '../../../../../store';

const useDocumentViewState = createStateSelectorHook(DocumentStore, [
  'detailsPanelVisibleForInstanceId',
]);

export const useDetailsVariation = (variations) => {
  const { detailsPanelVisibleForInstanceId: instanceId } = useDocumentViewState();
  return useMemo(
    () => variations.find((v) => v.instanceId === instanceId),
    [variations, instanceId]
  );
};
